import axiosInstance from '../axios.instance';
import { convertMillisecondsToHoursAndMinutes } from '../utils/convert';
import { ApiResponse, Station, Journey } from '../utils/types';

const getAllJourneysWithFilters = async (filters: {
    origineStation: string;
    destinationStation: string;
    departureDate: Date;
    returnDate?: Date;
}): Promise<ApiResponse<Journey>> => {
    let data = {
        total_count: 0,
        results: [],
    } as ApiResponse<Journey>;
    try {
        const response = await axiosInstance.get('/destination/journeys', {
            params: filters,
        });
        data = await response.data;
        data.results = data.results.map((unformattedJourney: any) => {
            return {
                arrivalTime: unformattedJourney.arrival_time,
                departureTime: unformattedJourney.departure_time,
                destinationIata: unformattedJourney.destination_iata,
                origineIata: unformattedJourney.origine_iata,
                travelTime: convertMillisecondsToHoursAndMinutes(
                    unformattedJourney.travel_time
                ),
                ...unformattedJourney,
            } as Journey;
        });
    } catch (error) {
        console.error('Error while fetching journeys:', error);
    }
    return data;
};

const getAllDestinationsFromOrigine = async (
    origineStation: string,
    departureDate: Date,
    returnDate?: Date
): Promise<ApiResponse<Station>> => {
    let data = {
        total_count: 0,
        results: [],
    } as ApiResponse<any>;
    try {
        const response = await axiosInstance.post('/destinations', {
            origineStation,
            departureDate: departureDate,
            returnDate: returnDate,
            odHappyCard: null,
            groupByStation: true,
        });
        data = await response.data;
    } catch (error) {
        console.error('Error while fetching destinations:', error);
    }
    return data;
};

export { getAllJourneysWithFilters, getAllDestinationsFromOrigine };
